"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var intl_format_1 = require("@biw/intl-format");
var get_label_string_1 = require("./get-label-string");
var contests_constants_1 = require("@biw/contests-constants");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var getChallengePointBaseEarningDescription = function (_a) {
    var baseLevel = _a.baseLevel, programType = _a.programType, locale = _a.locale, getString = _a.getString, goalRoundingMethod = _a.goalRoundingMethod, goalPayoutTierType = _a.goalPayoutTierType, goalLabel = _a.goalLabel, mediaLabel = _a.mediaLabel;
    if (goalPayoutTierType == contests_constants_1.payoutType.PT__FIXED && programType === contests_constants_1.PT__CP) {
        var precision_1 = get_1.default(goalLabel, 'precision', 1);
        var formatCPString = function (value) { return get_label_string_1.getLabelString(goalLabel, value, precision_1, goalRoundingMethod, locale); };
        var cpBaseEarningDescriptionReplaceOpts = {
            awardThreshold: formatCPString(baseLevel.awardThreshold),
            incrementAward: baseLevel.incrementAward,
            incrementQuantityStr: formatCPString(baseLevel.incrementQuantity),
            maxPoints: intl_format_1.formatNumber(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }, baseLevel.maxPoints),
            mediaLabel: mediaLabel
        };
        var _b = tslib_1.__read(getString('goalSelection.challengePoint.baseEarningDescription').split('#IF'), 4), baseDescription = _b[0], 
        // "<p>Earn <strong>${incrementAward} ${mediaLabel}</strong> for every <strong>${incrementQuantityStr} </strong>"
        awardThreshold = _b[1], 
        // " over <strong>${awardThreshold} </strong>"
        maximum = _b[2], 
        // " (up to <strong>${maxPoints} ${mediaLabel}</strong> maximum).</p>\r\n"
        challengeDescription = _b[3]
        // "\r\n<p><strong>But wait, here's the challenge!</strong></p>"
        ;
        var descriptionParts = [baseDescription];
        if (baseLevel.awardThreshold) {
            descriptionParts.push(awardThreshold);
        }
        if (baseLevel.maxPoints) {
            descriptionParts.push(maximum);
        }
        var description = descriptionParts.join('').template(cpBaseEarningDescriptionReplaceOpts);
        return ["" + description + challengeDescription, description];
    }
    return null;
};
getChallengePointBaseEarningDescription.propTypes = {
    baseLevel: prop_types_1.default.object,
    programType: prop_types_1.default.string,
    locale: prop_types_1.default.shape({}),
    getString: prop_types_1.default.func,
    goalRoundingMethod: prop_types_1.default.string,
    goalPayoutTierType: prop_types_1.default.string,
    goalLabel: prop_types_1.default.object,
    mediaLabel: prop_types_1.default.string
};
exports.default = getChallengePointBaseEarningDescription;
//# sourceMappingURL=get-challenge-point-base-earning-descriptions.js.map